import EmployeeList from './Employee';
import EmployeeForm from './EmployeeForm';
const EmployeeConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/employee',
            element: <EmployeeList />,
        },
        {
            path: '/addEmployee',
            element: <EmployeeForm />,
        },
        {
            path: '/editEmployee/:id',
            element: <EmployeeForm />,
        },
    ],
};

export default EmployeeConfig;
